import { debounce } from 'js-utils/src/function';
import init from "../../common/base/init";

init(() => {
  const highlightsActivator = document.getElementById('highlights-activator');

  if (!highlightsActivator) return;

  // Re-select inside handlers for iOS Safari reliability
  const contentInput = document.getElementById('highlights_bookmark_content_bookmarkable_content');
  const highlightsHelper1 = document.createRange();
  highlightsHelper1.selectNode(document.getElementById('highlights-helper-1'));
  const highlightsHelper2 = document.createRange();
  highlightsHelper2.selectNode(document.getElementById('highlights-helper-2'));

  function positionActivatorFromSelection() {
    const selection = window.getSelection && window.getSelection();
    if (!selection || selection.isCollapsed) return;

    let range;
    try {
      range = selection.getRangeAt(0);
    } catch (_) {
      return;
    }

    // Check if selection is within .the-article__content or .the-article__intro
    const container = range.commonAncestorContainer;
    const parentElement = container.nodeType === Node.TEXT_NODE ? container.parentElement : container;
    const isWithinArticleContent = parentElement.closest('.the-article__content');
    const isWithinArticleIntro = parentElement.closest('.the-article__intro');

    if (!isWithinArticleContent && !isWithinArticleIntro) {
      highlightsActivator.style.display = 'none';
      return;
    }

    // iOS: getBoundingClientRect can be empty; fallback to first client rect
    let rect = range.getBoundingClientRect();
    if ((!rect || (rect.width === 0 && rect.height === 0)) && typeof range.getClientRects === 'function') {
      const rects = range.getClientRects();
      if (rects && rects.length) rect = rects[0];
    }
    if (!rect || (rect.width === 0 && rect.height === 0)) return;

    const rb1 = highlightsHelper1.getBoundingClientRect();
    const rb2 = highlightsHelper2.getBoundingClientRect();

    const dy = rb1.top - rb2.top;
    const dx = rb1.left - rb2.left;

    // Avoid divide-by-zero
    const topPct = dy !== 0 ? ((rect.bottom - rb2.top) * 100) / dy : 0;
    const leftPct = dx !== 0 ? ((rect.left - rb2.left) * 100) / dx : 0;

    highlightsActivator.style.top = topPct + 'px';
    highlightsActivator.style.left = leftPct + 'px';

    const highlightedText = selection.toString();
    if (contentInput) contentInput.value = highlightedText;

    highlightsActivator.style.display = 'block';
  }

  const onUp = debounce(50, positionActivatorFromSelection);

  // Mouse and pointer events (for iPadOS with trackpad)
  window.addEventListener('mouseup', onUp);
  window.addEventListener('pointerup', onUp);

  // iOS Safari: selection finalizes after touchend; slight timeout helps
  window.addEventListener('touchend', () => {
    setTimeout(positionActivatorFromSelection, 60);
  }, { passive: true });

  function hideActivatorSoon() {
    setTimeout(() => {
      const selection = window.getSelection && window.getSelection();
      // Don't hide if there's still an active selection
      if (selection && !selection.isCollapsed) return;

      highlightsActivator.style.display = 'none';
    }, 150);
  }

  window.addEventListener('mousedown', debounce(50, hideActivatorSoon));
  window.addEventListener('pointerdown', debounce(50, hideActivatorSoon));
  window.addEventListener('touchstart', () => {
    // Hide quickly on touchstart to avoid overlap with native selection UI
    hideActivatorSoon();
  }, { passive: true });
});
